import api from 'Plugins/api'
import Insurance from '../entities/insurance'

class InsuranceInteractor {
  /**
   * 获取保险产品列表
   * @param {String} cplx 产品类型
   */
  static async getProductList (cplx) {
    try {
      const { data = [] } = await api['bx/getBxcpList']({ cplx })

      return {
        data: data.map(insurance => new Insurance(insurance))
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 获取关联的保险订单
   * @param {String} glddId 关联订单Id
   */
  static async getInsuranceOrderById (glddId) {
    try {
      const { data = {} } = await api['bx/getBxOrder']({ glddId })

      return {
        bxcpList: data.bxcpList ? data.bxcpList.map(insurance => new Insurance(insurance)) : [],
        totalPrice: data.bxTotalPrice || 0
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * 保险下单
   * @param {Object} order 下单关联订单信息
   * @param {Insurance[]} insuranceList 选中的保险列表
   */
  static async book (order, insuranceList) {
    try {
      if (insuranceList.length > 0 && order.orderId) {
        let params = {
          bxcpList: insuranceList.map(bx => bx.filterFields()),
          cplx: order.cplx,
          orderId: order.orderId,
          psgList: order.passengerList.map((item) => {
            return { 'birthDate': item.born }
          })
        }
        await api['bx/bookBx'](params)
      }
    } catch (error) {
      throw error
    }
  }
}

export default InsuranceInteractor